export const promotionCardButtonAction = {
  approval: 'approval',
  link: 'link',
  lead: 'lead',
  tradeInLead: 'tradeInLead',
  brandsLead: 'brandsLead',
};
export const SORT_NEW_CAR_TYPE = {
  priceHighToLow: 'price high to low',
  priceLowToHigh: 'price low to high',
};
